import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import { languageHelper } from "../../../../config/helperFunctions";

function DetailedPurchaseReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Date"),
      accessorKey: "date",
    },
    {
      header: languageHelper("Ingredient(Code)"),
      accessorKey: "code",
    },

    {
      header: languageHelper("Unit Price"),
      accessorKey: "price",
    },
    {
      header: languageHelper("Quantity/Amount"),
      accessorKey: "qty",
    },
    {
      header: languageHelper("Value(Qty)"),
      accessorKey: "Value(Qty)",
      cell: (row) =>
        `${row.row.original?.unit}(${row.row.original?.unit_value})`,
    },
    {
      header: languageHelper("Amount"),
      cell: (row) =>
        (row.row.original?.total - row.row.original?.total_vat_price)?.toFixed(
          2
        ),
    },
    {
      header: languageHelper("Vat Percentage"),
      accessorKey: "vat_percentage",
      cell: (row) => row.getValue() + "%",
    },
    {
      header: languageHelper("Tax method"),
      accessorKey: "tax_method",
      cell: (row) =>
        row.getValue() === "inclusive"
          ? languageHelper("Inclusive")
          : languageHelper("Exclusive"),
    },
    {
      header: languageHelper("Vat"),
      accessorKey: "total_vat_price",
      cell: (row) => row.getValue().toFixed(2),
    },
    {
      header: languageHelper("Total"),
      accessorKey: "total",
    },
  ];
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/detailed-purchase-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
          start_date: startDate,
          end_date: endDate,
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error(
          "There was an error fetching the detailed purchase report!",
          error
        );
      });
  }, [endDate, startDate, user?.user.outlet_id, user?.token]);

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Detailed Purchase Report")}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
    </main>
  );
}

export default DetailedPurchaseReport;
